import { SportType } from '../../../models/court/dto/court.dto';

export type AnalyticsFilterParams = {
    courtIds?: number[];
    sportTypes?: SportType[];
};

export function buildFilterSuffix(filters?: AnalyticsFilterParams): string {
    if (!filters) return '';
    let suffix = '';
    if (filters.courtIds?.length) {
        suffix += `&courtIds=${filters.courtIds.join(',')}`;
    }
    if (filters.sportTypes?.length) {
        suffix += `&sportTypes=${filters.sportTypes.join(',')}`;
    }
    return suffix;
}
